import { render, staticRenderFns } from "./ReviewsCategoriesAnalytics.vue?vue&type=template&id=4e5b0943&scoped=true&"
import script from "./ReviewsCategoriesAnalytics.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesAnalytics.vue?vue&type=style&index=0&id=4e5b0943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b0943",
  null
  
)

export default component.exports